
import Vue from "vue";
import { AWSFileService } from "@/services/aws-file-service";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { AWSFile } from "@/models/aws-file";
import { ISelectItem } from "winfakt-vue-components";
import { SaleLayoutAttachment, SaleLayoutAttachmentPosition } from "@/utils/sale-layouts/attachment";
import { createConfirmBuilder } from "@/setup/confirm-builder";
import AppConditionsEdit from "@/components/models/ConditionsEdit.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSalePropSelectGroup } from "@/utils/prop-select/sale-to-prop-group";

export default Vue.extend({
	data(){
		return {
			allFiles: [] as AWSFile[],
			sending: false
		};
	},
	props: {
		settings: {
			type: Object as ()=>SaleLayout,
			required: true
		}
	},
	computed: {
		fileList():ISelectItem<string>[]{
			let files = this.allFiles.map(f=>{
				return {
					text: f.Name,
					value: f.Name
				} as ISelectItem<string>;
			});
			return [{
					text: this.$ct("common.none"),
					value: ""
				},
				...files];
		},
		selectedFile():string | null {
			if (!this.settings.Attachment) {
				return null;
			}
			return this.settings.Attachment.FileName;
		},
		allowedExtensions():string[]{
			return ["pdf"];
		},
		positions():ISelectItem<SaleLayoutAttachmentPosition>[] {
			return [
				{
					text: this.$ct(SaleLayoutAttachmentPosition.BACK_SIDE),
					value: SaleLayoutAttachmentPosition.BACK_SIDE
				},
				{
					text: this.$ct(SaleLayoutAttachmentPosition.END),
					value: SaleLayoutAttachmentPosition.END
				}
			];
		},
		propSelectGroup():PropSelectGroup{
			return getSalePropSelectGroup();
		}
	},
	methods: {
		async getAllFiles() {
			this.allFiles = await AWSFileService.listFiles("/layout-attachments");
		},
		async onFileInput(file: File){
			this.sending = true;
			let result = await AWSFileService.uploadFile("/layout-attachments", file);
			this.getAllFiles();
			this.sending = false;
			this.selectFile(result.Name);
		},
		selectFile(file:string){
			if (!file) {
				this.settings.Attachment = null;
				return;
			}
			if (!this.settings.Attachment) {
				this.settings.Attachment = new SaleLayoutAttachment();
			}
			this.settings.Attachment.FileName = file;
		},
		async deleteAttachment():Promise<void>{
			let confirmBuilder = createConfirmBuilder.bind(this)();
			confirmBuilder.setMessage( this.$ct("confirm-delete-attachment"));
			confirmBuilder.setTitle(this.$ct("common.warning"));
			confirmBuilder.setClass("warning");
			let confirm = await confirmBuilder.show();
			if (!confirm) return;
			if (!this.settings.Attachment) return;
			let a = this.settings.Attachment;
			let file = this.allFiles.find(f=>f.Name == a.FileName);
			if (!file) return;
			await AWSFileService.deleteFiles([file]);
			this.settings.Attachment = null;
			this.getAllFiles();
		},
		async downloadAttachment(){
			let a = this.settings.Attachment;
			if (!a) return;
			let file = this.allFiles.find(f=>f.Name == (a as SaleLayoutAttachment).FileName);
			if (!file) return;
			await AWSFileService.downloadFile(file.Token, file.Name);
		}
	},
	async created(){
		await this.getAllFiles();
	},
	components: {
		AppFileUpload,
		AppConditionsEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
